import { Injectable, OnDestroy } from "@angular/core";
import { TimeoutWrapper } from "../timeout.wrapper/timeout.wrapper";

@Injectable({
  providedIn: 'root'
})
export class TimeoutWrapperService extends TimeoutWrapper implements OnDestroy {
  // see https://github.com/angular/angular/issues/22466
  // for reasons why we don't use {provide: xx, useClass: yy} syntax

  constructor() {
    super();
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }
}
